import React from 'react';
import useFetchData from '../../crud/useFetchData';
import GrupoUI from './GrupoUI';
import {proto,url} from '../../Helpers/api'

export default function Grupo() {
  const {
    isLoading,
    isFinished,
    error,
    data=[],
    refresh,
  } = useFetchData(`${proto}://${url}/grupos/mytest/list`)
  // } = useFetchData(`${proto}://${url}/main/mytest/list`)
  if (isLoading) return <div>Carregando dados...</div>;
  if (error) return <div>Erro! {error}</div>;
  if (!isFinished || !data.length) return null
  return (
    <GrupoUI
      data={data}
      refresh={refresh}
    />
  )
}
